import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';

@Component({
  selector: 'app-prodcut-modify',
  templateUrl: './prodcut-modify.component.html',
  styleUrls: ['./prodcut-modify.component.css']
})
export class ProdcutModifyComponent implements OnInit {

  form: any | FormGroup
  paramData:any = []
  productCompositionData: any = []
  imgUrl1 = ''
  imgUrl2 = ''
  file1: File | undefined;
  file2: File | undefined;
  singleproductCompositionData: any= []
  deleteProductCompositionId = ""
  page: number = 1;
  count: number = 0;
  tableSize: number = 10;
  tableSizes: any = [3, 6, 9, 12];
  products:any = []
  uomData: any = []
  prodcutid: any = "";
  cid:any

  constructor(private fb: FormBuilder,private toastr: ToastrService,private generic_service: GenericService) { }

  ngOnInit(): void {
    this.cid = sessionStorage.getItem('cid')
    this.getAllUomMaster()
    // this.generic_service.getProduct().subscribe(
    //   (res:any)=>{
    //     this.products = res.response
    //   }
    // )
    this.getAllProductComposition()
    this.form = this.fb.group({
      productName: [''],
      description: [''],
      productCompositionIngList:this.fb.array([]),
    })
    this.addInfoObject()
  }

  onTableDataChange(event: any) {
    this.page = event;
    this.getAllProductComposition();
  }
  onTableSizeChange(event: any): void {
    this.tableSize = event.target.value;
    this.page = 1;
    this.getAllProductComposition();
  }

  get paramArr(){
    return this.form.get('productCompositionIngList') as FormArray;
  }

  paramObject(){
    return this.fb.group({
      "name": [''],
      "qty": [''],
      "uom": [''],
      "price": ['']
    })
   }
  
   addInfoObject(){
    // this.infoArr.clear()
    this.paramArr.push(this.paramObject())
   }

   removeParamObject(index: number){
    this.paramArr.removeAt(index)
   }

   getAllUomMaster(){
    this.generic_service.getAllUomMaster().subscribe(
      (res:any)=> {
        console.log(res)
        this.uomData = res.response
      },
      (err:any)=>{
        console.log(err)
      }
    )
  }

  updateProdcutComposition(){
    let body = {
      "id":this.prodcutid,
      "version": 0,
      "isActive": true,
      "description": String(this.form.get('description').value),
      "productName": String(this.form.get('productName').value),
      "productCompositionIngList": this.form.get('productCompositionIngList').value,
      "cid": this.cid
    }

    console.log(body)
    this.generic_service.updateProdcutComposition(body).subscribe(
      (response:any) => {
        console.log(response)
        this.getAllProductComposition()
        this.toastr.success("Successfully Updated")
        this.cancelModel()
      },
      (error:any)=>{
        console.log(error)
      }
    )
  }

  cancelModel(){
    document.getElementById("closeModalButton")?.click()
    document.getElementById("closeModalButton1")?.click()
  }

  getAllProductComposition(){
    this.generic_service.getAllProductCompositionWithoutPagination().subscribe(
      (res:any)=> {
        console.log(res)
        this.productCompositionData = res.response
      },
      (err:any)=>{
        console.log(err)
      }
    )
  }

  getProductCompositionById(id:any){
    this.prodcutid = id
    this.form.reset()
    this.paramArr.clear()

    this.generic_service.getProductCompositionById(id).subscribe(
      (response:any)=>{
        console.log(response)
        // this.singleproductCompositionData = []
        // this.singleproductCompositionData.push(response.response)
        this.form.patchValue({
          productName: response.response.productName,
          description: response.response.description,
          // productCompositionIngList: response.response.productCompositionIngList
        })
        for(var i=0; i<response.response.productCompositionIngList.length; i++){
          let obj = this.fb.group({
            "name":[response.response.productCompositionIngList[i].name],
            "qty":[response.response.productCompositionIngList[i].qty],
            "uom":[response.response.productCompositionIngList[i].uom],
            "price":[response.response.productCompositionIngList[i].price]
          })
          this.paramArr.push(obj)
        }
      },
      (err:any)=> {
        console.log(err)
      }
    )
  }

}

